<template>
  <div class="virtual-ip-management" style="width: 100%">
    <div class="title-bar title-h3">IP 사용현황</div>
    <!-- 범례 -->
    <el-row class="color-wrapper">
      <span class="color unknown"></span> 미확인
      <span class="color vm"></span> VM
      <span class="color gateway"></span> 게이트웨이
      <span class="color host"></span> 호스트
      <span class="color template"></span> 템플릿
      <span class="color broadcast"></span> 브로드캐스트
    </el-row>
    <div>
      <div v-if="showEmptyBox" class="empty_box">
        <span class="empty_text">데이터가 없습니다.</span>
      </div>
      <el-tooltip v-else popper-class="heatmap virtual-ip-table" placement="bottom" v-for="(item, index) in ipList" :key="item.ip" :disabled="setTooltipDisabledFlag(item)">
        <div slot="content" v-if="item.type === 'VM'">
          <p><span>VM  |  {{ getValueAfterCheckEmpty(item.data.name) }}</span></p>
          <p><span>IP  |  {{ getValueAfterCheckEmpty(item.ip) }}</span></p>
          <p><span>OS  |  {{ getValueAfterCheckEmpty(item.data['VVM_COMMON/OS']) }}</span></p>
          <p><span>상태  |  {{ getValueAfterCheckEmpty(item.data['VVM_COMMON/ALIVE']) }}</span></p>
          <p><span>담당자  |  {{ getValueAfterCheckEmpty(item.data.vmuserId) }}</span></p>
        </div>
        <div slot="content" v-else-if="item.type === 'TEMPLATE'">
          <p><span>템플릿  |  {{ getValueAfterCheckEmpty(item.name) }}</span></p>
          <p><span>IP  |  {{ getValueAfterCheckEmpty(item.ip) }}</span></p>
          <p><span>OS  |  {{ getValueAfterCheckEmpty(item.data['VVM_COMMON/OS']) }}</span></p>
        </div>
        <div slot="content" v-else-if="item.type === 'VHO'">
          <p><span>호스트  |  {{ getValueAfterCheckEmpty(item.data.name) }}</span></p>
          <p><span>IP  |  {{ getValueAfterCheckEmpty(item.ip) }}</span></p>
          <p><span>모델  |  {{ getValueAfterCheckEmpty(item.data['VHO_SYSTEM/MODEL_NAME']) }}</span></p>
          <p><span>VM수  |  {{ getValueAfterCheckEmpty(item.data['VHO_COMMON/VM_COUNT']) }}</span></p>
        </div>
        <el-button class="node-small" :style="getIpCellStyle(item)">{{ index }}</el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { getValueAfterCheckEmpty } from '@/utils/string';
import provisioningSettingApi from '@/api/settings/virtual/provisioning-settings';

export default {
  name: 'WIpTable',
  props: {
    selectedRow: {
      type: Object,
    },
  },
  data() {
    return {
      ipList: [],
      showEmptyBox: false,
    };
  },
  methods: {
    getValueAfterCheckEmpty,
    clearIpTable() {
      this.ipList = [];
      this.showEmptyBox = false;
    },
    loadData() {
      if (this.selectedRow) {
        this.clearIpTable();
        const params = {
          hostId: this.selectedRow.hostId,
          rangeId: this.selectedRow.rangeId,
          attrInfoParams: [
            { attrTypeId: 'VHO_COMMON', attrId: 'VM_COUNT' },
            { attrTypeId: 'VHO_SYSTEM', attrId: 'MODEL_NAME' },
            { attrTypeId: 'VVM_COMMON', attrId: 'ALIVE' },
            { attrTypeId: 'VVM_COMMON', attrId: 'OS' },
          ],
        };
        provisioningSettingApi.getCurrentIpTableList(params).then((response) => {
          if (response.data.success) {
            this.ipList = response.data.data;
            this.showEmptyBox = this.ipList.length === 0;
          }
        }).catch(() => {
          this.showEmptyBox = true;
        });
      } else {
        this.showEmptyBox = true;
      }
    },
    /**
     * 툴팁 disable 여부 (vm, 템플릿, 호스트에서만 툴팁 표현)
     * @author jeee12
     * @param  {[type]} item [description]
     */
    setTooltipDisabledFlag(item) {
      return !item.type || (item.type !== 'VM' && item.type !== 'TEMPLATE' && item.type !== 'VHO');
    },
    /**
     * IP 테이블 type마다 색상 표현
     * (NETWORK, GATEWAY, BROADCAST, 미확인, VM, 템플릿, 호스트)
     * @author jeee12
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    getIpCellStyle(item) {
      const defaultCellStyle = { cursor: 'default', marginBottom: '2px' };
      if (item.type === 'NETWORK') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#DCDCDC',
          color: '#FFFFFF',
          border: 0,
        };
      } else if (item.type === 'UNKNOWN') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#FF2B5D',
          color: '#FFFFFF',
          border: 0,
        };
      } else if (item.type === 'VM') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#5AE671',
          color: '#FFFFFF',
          border: 0,
        };
      } else if (item.type === 'GATEWAY') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#80B7FF',
          color: '#FFFFFF',
          border: 0,
        };
      } else if (item.type === 'VHO') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#FE9A2E',
          color: '#FFFFFF',
          border: 0,
        };
      } else if (item.type === 'TEMPLATE') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#928CED',
          color: '#FFFFFF',
          border: 0,
        };
      } else if (item.type === 'BROADCAST') {
        return {
          ...defaultCellStyle,
          backgroundColor: '#A1FFFD',
          color: '#FFFFFF',
          border: 0,
        };
      }
      return defaultCellStyle;
    },
  },
};
</script>

<style lang="scss">
.virtual-ip-table.heatmap.el-tooltip__popper {
  max-width: none !important;
}
.virtual-ip-management {
  .color-wrapper {
    text-align: right;
    padding-right: 15px;
  }
  .network {
    background: #DCDCDC;
    border: 0;
  }
  .unknown {
    background: #FF2B5D;
    border: 0;
  }
  .vm {
    background: #5AE671;
    border: 0;
  }
  .gateway {
    background: #80B7FF;
    border: 0;
  }
  .host {
    background: #FE9A2E;
    border: 0;
  }
  .template {
    background: #928CED;
    border: 0;
  }
  .broadcast {
    background: #A1FFFD;
    border: 0;
  }
  .empty_box {
    width: 100%;
    min-height: 180px;
    display: table;
    .empty_text {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/IpRangeSetting/components/IpTable.vue